import React, { useCallback, useEffect, useState} from "react";
import {
  Typography,
  Box,
  TextField,
  Autocomplete,
  Tabs,
  Tab,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import { useHistory, useLocation } from "react-router";
import { ROUTE_PATHS } from "src/routes";
import { DroughtCatalogDetailTab } from "./catalog_detail_tab/DroughtCatalogDetailTab";
import { deleteModalStyle, modalStyle } from "src/shared/Styles/Styles";
import { AddDroughtCatalog } from "../modals/AddDroughtCatalog";
import CloseIcon from '@mui/icons-material/Close';
import { useStoreContext } from "src/store/context";
import { useAddAlert } from "src/store/actions";
import { getDroughtCatalogCall } from "src/apis/getCatalogCalls";
import { alertMessages } from "src/constants";
import { checkAdminRole } from "src/store/common";
import { DeleteCatalog } from "../modals/DeleteCatalog";
import { AuditCatalog } from "./catalog_audits/AuditCatalog";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box >{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function DroughtCatalogDetail({tab}) {
  const history = useHistory();
  const location = useLocation();
  const [state, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);

  const [tabValue, setTabValue] = useState(tab);
  const [droughtCatalog, setDroughtCatalog] = useState<any>(null);
  const [routes, setRoutes ] = useState<string[]>([]);
  const [searchedDroughtCatalog, setSearchedDroughtCatalog] = useState<any>(null);
  const [searchOptions, setSearchOptions] = useState<any[]>([])

  const [openDroughtModal, setOpenDroughtModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [createUpdateDroughtSuccess, setCreateUpdateDroughtSuccess] = useState<boolean>(false);
  const [deleteDroughtCatalogSuccess, setDeleteDroughtCatalogSuccess] = useState<boolean>(false);
  const [editDrought, setEditDrought] = useState<string>('');

  /** Make the api call for the fuel catalog detail */
  const droughtCatalogCallback = useCallback((request: any, search?: boolean) => {
    (async () => {
      try {
        const droughtCatalogResponse: any = await getDroughtCatalogCall(request, addAlert);
        if (droughtCatalogResponse.data.length > 0) {
          if (search) {
            setSearchOptions(droughtCatalogResponse.data)
          }
          else {
            setDroughtCatalog(droughtCatalogResponse.data[0]);
          }
        } else {
          search ? setSearchOptions([]) : setDroughtCatalog(null);
        }
        setCreateUpdateDroughtSuccess(false);

      } catch (error) {
        search ? setSearchOptions([]) : setDroughtCatalog(null);
        setCreateUpdateDroughtSuccess(false);
        addAlert({
          id: '',
          message: alertMessages.retrieveCatalog,
          type: 'error-info',
          icon: 'fa-exclamation-triangle'
        });
      }
    })();
  }, [addAlert]);

  const clickViewAllDroughtCatalogs = useCallback(()=>{
    history.push({
      pathname: `${ROUTE_PATHS.table}${ROUTE_PATHS.droughtTab}`,
      state: {...droughtCatalog, page: 0, perPage: 10}
    })
  }, [history, droughtCatalog]);

  useEffect(()=>{
    if(location?.state){
      const thisDroughtCatalog:any = location.state;
      if(thisDroughtCatalog.from){
        setSearchedDroughtCatalog(thisDroughtCatalog)
      }
      setEditDrought(thisDroughtCatalog?.id)
      setDroughtCatalog(thisDroughtCatalog);
      setRoutes([`${ROUTE_PATHS.table}${ROUTE_PATHS.droughtTab}/detail/${thisDroughtCatalog?.id}`, 
      `${ROUTE_PATHS.table}${ROUTE_PATHS.droughtTab}/audit/${thisDroughtCatalog?.id}`
      ])
    }
    else{
      const stringArray = decodeURIComponent(location.pathname).split("/");
      const catalogId = stringArray[stringArray?.length-1];
      const request = {
        id: Number(catalogId),
        perPage: 10000,
        page: 0,
        sortBy: 'kbdi_parameter_catalog_name',
        sortOrder: 'asc',
      }
      droughtCatalogCallback(request);
      setRoutes([`${ROUTE_PATHS.table}${ROUTE_PATHS.droughtTab}/detail/${catalogId}`, 
      `${ROUTE_PATHS.table}${ROUTE_PATHS.droughtTab}/audit/${catalogId}`
      ])
    }
  },[location?.pathname, location.state, droughtCatalogCallback ])

  /* call to get search optiions*/
  useEffect(() => {
    const requestSearch = {
      id: null,
      catalogName: null,
      perPage: 10000,
      page: 0,
      sortBy: 'kbdi_parameter_catalog_name',
      sortOrder: 'asc',
    }
    droughtCatalogCallback(requestSearch, true)
  }, [droughtCatalogCallback])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    history.push({
      pathname: `${routes[newValue]}`,
      state: {...droughtCatalog}
    });
  };

  /*successful save or update or delete*/
  useEffect(() => {
    if(createUpdateDroughtSuccess){
      const request = {
        id: Number(droughtCatalog.id),
        perPage: 10000,
        page: 0,
        sortBy: 'kbdi_parameter_catalog_name',
        sortOrder: 'asc',
      }
      droughtCatalogCallback(request);
      //call for search options
      const requestSearch = {
        id: null,
        catalogName: null,
        perPage: 10000,
        page: 0,
        sortBy: 'kbdi_parameter_catalog_name',
        sortOrder: 'asc'
      }
      droughtCatalogCallback(requestSearch, true);
    } else if(deleteDroughtCatalogSuccess) {
      clickViewAllDroughtCatalogs();
    }
  }, [droughtCatalogCallback, createUpdateDroughtSuccess, deleteDroughtCatalogSuccess, droughtCatalog, clickViewAllDroughtCatalogs]);

  const handleCloseDroughtModal = (_event: any, reason: any) => {
    if (reason && reason === "backdropClick") {
      setOpenDroughtModal(false);
    }
    setOpenDroughtModal(false);
    setEditDrought('')
  }

  const onDroughtCatalogSearch = (e: React.SyntheticEvent<Element, Event>, incomingVal: any) => {
    history.push(
      { pathname: `${ROUTE_PATHS.table}${ROUTE_PATHS.droughtTab}/detail/${incomingVal?.id}`, state: { ...incomingVal, from: 'search' } }
    )
  }
  
  const handleDeleteCatalog = () => {
    setOpenDeleteModal(true);
  }
  
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  }

  return (
    <Box>
      <Modal //Modal to open edit/create drought
        className="smooth-scrollbar"
        open={openDroughtModal}
        onClose={handleCloseDroughtModal}
      >
        <div>
          <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenDroughtModal(false) }}>
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding" >
            {
              <AddDroughtCatalog setOpen={setOpenDroughtModal} setCreateUpdateDroughtSuccess={setCreateUpdateDroughtSuccess} editDrought={editDrought}/>
            }
          </Box>
        </div>
      </Modal>
      <Modal //Modal to delete catalog
        className="smooth-scrollbar"
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
      >
        <div style={{ height: '100%' }}>
          <IconButton aria-label='close' style={{ left: '64%', top:'23.5%', position: 'absolute', cursor: 'pointer' }} onClick={(e)=>handleCloseDeleteModal()} >
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={deleteModalStyle} className="smooth-scrollbar removePadding" >
            { state.user && checkAdminRole(state.user) &&
              <DeleteCatalog setOpenDeleteModal={setOpenDeleteModal} setDeleteFuelCatalogSuccess={setDeleteDroughtCatalogSuccess} deleteCatalogId={droughtCatalog?.id} catalogName={droughtCatalog?.name} catalogCategory={'Drought'}/>
            }
          </Box>
        </div>
      </Modal>

      {/* Toolbar */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 2,
        }}
      >
        {/* Left Section */}
        <Box sx={{display: 'flex', flexDirection:'column'}}>
          <Typography variant="h5">
            <span style={{marginRight: '1rem', textTransform:'capitalize'}}>{droughtCatalog?.name}</span> 
            <Button variant="contained" onClick={()=> {setOpenDroughtModal(true)}}>Edit Catalog</Button>
            { droughtCatalog?.id !== 1 &&
            <Button variant="contained" color='error' style={{marginLeft:'1rem'}} onClick={()=>handleDeleteCatalog()}>Delete Catalog</Button>
            }
          </Typography>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", flexDirection: "column", marginRight: '1rem',alignItems: "flex-end", width: '25vw' }}>
          <div className="searchStationsDownloadPage">
            {/* Search Icons */}
            <i className="fas fa-search"/>
            <Autocomplete
              id="droughtDetailCatalogSearch"
              clearOnEscape
              freeSolo
              noOptionsText={
                <div className='no-results'>
                    <div>No results match your search criteria.</div>
                </div>
              }
              options={searchOptions}
              getOptionLabel={(option)=>`${option.name}`}           
              aria-label="droughtDetailCatalogSearch"
              value={searchedDroughtCatalog}
              onChange={(event, newValue) => onDroughtCatalogSearch(event, newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Search Drought Catalogs...'}
                  placeholder="Search Drought Catalogs..."
                />
              )}
            />
          </div>
          <Box mt={1}>
            <Button variant='text' onClick={clickViewAllDroughtCatalogs} className="font-sans-sm text-bold" style={{ color: "#1675e0", textTransform:'capitalize' }}>
              View All Drought Catalogs
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Tabs Section */}
      <Box sx={{ width: "100%", marginTop: 3 }}>
        <Box>
        {/* Tabs Section */}
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="custom tabs example"
            className="tabcatalog"
          >
            <Tab label="Details" {...a11yProps(0)} />
            <Tab label="Audit Logs" {...a11yProps(1)} />

          </Tabs>
        </Box>
        {/* Tab Panels */}
        <CustomTabPanel value={tabValue} index={0}>
          <div style={{backgroundColor: '#dddddd', height: '60vh'}}>
            <DroughtCatalogDetailTab droughtCatalog={droughtCatalog} />
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <div style={{backgroundColor: '#eeeeee', height: '100%'}}>
            <AuditCatalog catalogType={'Drought'}/>
          </div>
        </CustomTabPanel>
      </Box>

    </Box>
  );
}

export default DroughtCatalogDetail;